import React from "react";
import DOMPurify from "dompurify";

const SafeHtml = React.forwardRef(({ html, as: Tag = "div", ...rest }, ref) => {
  const sanitized = DOMPurify.sanitize(html ?? "");
  return (
    <Tag
      ref={ref}
      {...rest}
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
});

SafeHtml.displayName = "SafeHtml";

export default SafeHtml;
